import "@/App.css";
import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import ScrollToTop from "@/components/ScrollToTop";

const Home = lazy(() => import("@/pages/Home"));
const GuideList = lazy(() => import("@/pages/GuideList"));
const GuideDetail = lazy(() => import("@/pages/GuideDetail"));
const GadgetList = lazy(() => import("@/pages/GadgetList"));
const GadgetDetail = lazy(() => import("@/pages/GadgetDetail"));
const Method = lazy(() => import("@/pages/Method"));
const About = lazy(() => import("@/pages/About"));
const Disclosure = lazy(() => import("@/pages/Disclosure"));
const Privacy = lazy(() => import("@/pages/Privacy"));
const CookiePolicy = lazy(() => import("@/pages/CookiePolicy"));
const Terms = lazy(() => import("@/pages/Terms"));
const LegalNotice = lazy(() => import("@/pages/LegalNotice"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function Shell() {
  useLenis();
  return (
    <>
      <a href="#main-content" className="skip-link">
        Vai al contenuto
      </a>
      <ScrollToTop />
      <Nav />
      <main id="main-content" className="min-h-screen" tabIndex={-1}>
        <Suspense fallback={<div className="min-h-screen" aria-hidden="true" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/guide" element={<GuideList />} />
            <Route path="/guida/:slug" element={<GuideDetail />} />
            <Route path="/gadget" element={<GadgetList />} />
            <Route path="/gadget/:slug" element={<GadgetDetail />} />
            <Route path="/metodo" element={<Method />} />
            <Route path="/chi-sono" element={<About />} />
            <Route path="/disclosure" element={<Disclosure />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/cookie" element={<CookiePolicy />} />
            <Route path="/termini" element={<Terms />} />
            <Route path="/note-legali" element={<LegalNotice />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}
